export enum ThemeMap {
  LIGHT_MONOCHROME = 'lightMonochrome',
  GRAY_MONOCHROME = 'grayMonochrome',
  DARK_MONOCHROME = 'darkMonochrome',
}
